var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card card-custom card-transparent"},[_c('div',{staticClass:"card-body p-0"},[_c('div',{staticClass:"wizard",attrs:{"id":"kt_wizard_v4","data-wizard-state":"step-first","data-wizard-clickable":"true"}},[_c('FormHeader',{attrs:{"tabs":_vm.tabs}}),_c('FormBody',_vm._b({on:{"submit":function($event){return _vm.$emit('submit')}}},'FormBody',{
          tabs: _vm.tabs,
          submit_button: _vm.submit_button,
          next_button: _vm.next_button,
          previous_button: _vm.previous_button,
        },false),[_vm._t("default")],2)],1)]),_c('b-overlay',{attrs:{"show":_vm.loading,"no-wrap":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }